import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    context: 'requirement',
    viewPath: props.viewPath,
  })
  return function onClick() {
    change(next => {
      next.create_task = false
      next.create_task_new = true
      next.new_task = {
        title: null,
        board_id: null,
        stage_id: null,
        actions: [],
        tags: [],
        ...next.new_task,
      }
    })
  }
}
